import { push } from "connected-react-router";
import PropTypes from "prop-types";
import React from "react";
import DocumentTitle from "react-document-title";
import { connect } from "react-redux";

import listTablePoliciesSelectors from "../../listview/selectors";
import {
  groups,
  permissions,
  resourceTypes,
  roles,
  services,
  users
} from "../../policies/actions";
import { ProductShape, RoleShape } from "../../policies/proptypes";
import policiesSelectors from "../../policies/selectors";
import withModal from "../../shared/components/withModal";
import PermissionsList from "../components/PermissionsList";
import RoleActions from "../components/RoleActions";
import RoleDescription from "../components/RoleDescription";
import RolesList from "../components/RolesList";

export class Roles extends React.Component {
  componentDidMount() {
    const { fetchPermissions } = this.props;
    fetchPermissions();
  }

  componentDidUpdate() {
    const { roles, currentRole, setCurrentRole } = this.props;
    if (!currentRole && roles.length) {
      setCurrentRole(roles[0].$uri);
    }
  }

  openResources = uri => {
    const { setCurrentResourceType, push, parentUrl } = this.props;
    setCurrentResourceType(uri);
    push(`${parentUrl}/scopes`);
  };

  render() {
    const {
      roles,
      loading,
      currentRole,
      setCurrentRole,
      permissionsByProduct,
      parentUrl
    } = this.props;
    return (
      <div className="l-roles">
        <DocumentTitle title="RBAC - Roles" />
        <RolesList
          roles={roles}
          loading={loading}
          currentRole={currentRole}
          setCurrent={setCurrentRole}
        />
        <PermissionsList products={permissionsByProduct} loading={loading} />
        <RoleDescription
          role={currentRole}
          openResources={this.openResources}
          parentUrl={parentUrl}
        />
        <RoleActions parentUrl={parentUrl} />
      </div>
    );
  }
}

Roles.displayName = "Roles";

Roles.propTypes = {
  parentUrl: PropTypes.string.isRequired,
  currentRole: RoleShape,
  fetchPermissions: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  permissionsByProduct: PropTypes.arrayOf(ProductShape).isRequired,
  roles: PropTypes.arrayOf(RoleShape).isRequired,
  setCurrentResourceType: PropTypes.func.isRequired,
  setCurrentRole: PropTypes.func.isRequired,
  push: PropTypes.func.isRequired
};

Roles.defaultProps = {
  currentRole: undefined
};

const mapStateToProps = state => {
  let roles;
  let permissionsByProduct;

  if (window.location.pathname === "/settings") {
    roles = policiesSelectors.roles.getForRbacAdmin(state);
    permissionsByProduct = policiesSelectors.permissions.getForRbac(state);
  } else {
    roles = policiesSelectors.roles.get(state);
    permissionsByProduct = policiesSelectors.permissions.getByProduct(state);
  }

  return {
    loading: state.roles.loading,
    currentRole: policiesSelectors.roles.getCurrent(state),
    permissions: policiesSelectors.permissions.getByCurrentRole(state),
    policiesByRole: listTablePoliciesSelectors.getByRole(state),
    roles,
    permissionsByProduct
  };
};

const mapDispatchToProps = {
  fetchPermissions: permissions.request,
  setCurrentGroup: groups.setCurrent,
  setCurrentResourceType: resourceTypes.setCurrent,
  setCurrentRole: roles.setCurrent,
  setCurrentService: services.setCurrent,
  setCurrentUser: users.setCurrent,
  push
};

export default withModal(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Roles)
);
